/**
 * TOPのmp4の再生
 * @constructor
 */
class Movie {
  constructor() {

  }
  /**
   * TOPのmp4の再生
   */
  init() {
    var video_pc = $('#video_pc').get(0);
    var video_sp = $('#video_sp').get(0);
    var sp = window.matchMedia("(max-width: 750px)").matches;

    $(".js-soundBtn").on("click", function () {
      if (sp) {
        if (video_sp.muted) {
          video_sp.muted = false;
          $(this).addClass('is-active');
        } else {
          video_sp.muted = true;
          $(this).removeClass('is-active');
        }
      } else {
        if (video_pc.muted) {
          video_pc.muted = false;
          $(this).addClass('is-active');
        } else {
          video_pc.muted = true;
          $(this).removeClass('is-active');
        }
      }
    });
  }
  

}
export default Movie;
